import React from 'react';
import classNames from 'classnames/bind';

import styles from './Announce2025.module.scss';

const cx = classNames.bind(styles);

const Report2023 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <div className={cx('header')}>합병에 따른 채권자 이의 제출 및 주권제출 공고</div>
        <div className={cx('body')}>
          <div className={cx('inner')}>
            <p>
              풀무원샘물 주식회사(“갑”)와 샘소슬 주식회사(“을”)는 2025년 5월 13일 각 개최된 임시주주총회에서 특별결의에 따라{' '}
              <strong>
                (1) 을이 갑으로 합병되고, (2) 갑은 합병과 관련하여 을의 주주에게 합병신주를 행하지 않으며, (3) 합병결과 갑은 을의 모든 자산,
                부채, 권리 및 의무를 승계하고, (4) 을은 해산하기로 결의하였습니다.
              </strong>{' '}
              갑과 을의 채권자들께서는 본 합병에 대하여 이의가 있으시면 본 공고 게재 익일로부터 1개월 이내에 각 회사 본점에 이의제기를
              신청해 주시기 바랍니다. 또한 을의 주권을 가지고 계신 주주들께서는 을의 본점 사무소에 주권을 본 공고 게재 익일로부터 1개월
              이내에 제출하여 주시기 바랍니다.
            </p>
            <br />
            <p className={cx('date')}>2025년 5월 14일</p>
            <div className={cx('columns')}>
              <div className={cx('column')}>
                <div className={cx('role')}>갑</div>
                <div className={cx('lines')}>
                  <div className={cx('line')}>풀무원샘물&nbsp;</div>
                  <div className={cx('line')}>경기도 포천시 이동면 화동로 1870번길 142-24</div>
                  <div className={cx('line')}>
                    <strong>대표이사 백동옥</strong>
                  </div>
                </div>
              </div>
              <div className={cx('column')}>
                <div className={cx('role')}>을</div>
                <div className={cx('lines')}>
                  <div className={cx('line')}>샘소슬 주식회사</div>
                  <div className={cx('line')}>경상남도 밀양시 삼랑진읍 행곡1길 15-94</div>
                  <div className={cx('line')}>
                    <strong>대표이사 백동옥</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report2023;
